<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="盘点时间">
              <a-range-picker @change="dateChange" :defaultValue="[moment(queryParam.s_date, format), moment(queryParam.e_date, format)]"></a-range-picker>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="仓库">
              <a-select
                v-model="queryParam.storeId"
                placeholder="所有仓库"
              >
                <a-select-option value="0">所有仓库</a-select-option>
                <a-select-option v-for="item in storeData" :value="item.id" :key="item.id"> {{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="tableSearch">查询</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <s-table
      size="default"
      ref="table"
      :pageSize="20"
      :columns="columns"
      :data="loadData"
      bordered
      rowKey="id"
    >
      <span slot="pdNo" slot-scope="text, record">
        <a @click="toInventory(record)">{{ record.pdNo }}</a>
      </span>
      <span slot="storeId" slot-scope="text, record">
        <span v-if="record.store">{{ record.store.name }}</span>
        <span v-if="!record.store">所有仓库</span>
      </span>
      <span slot="pdResult" slot-scope="text, record">
        <div v-for="bill in record.bills" :key="bill.id">
          <router-link :to="{ path: relBillPath(bill.transType, bill.id) }">{{ bill.transType == TYPE_PANYING ? '盘盈单': '盘亏单' }} {{ bill.billNo }}</router-link>
        </div>
      </span>
      <span slot="action" slot-scope="text, record">
        <a-popconfirm placement="topLeft" title="确定要删除此盘点记录吗?删除后相关数据同时删除！" @confirm="deleteConfirm(record.id)" okText="确定" cancelText="取消">
          <a href="#">删除</a>
        </a-popconfirm>

      </span>
    </s-table>
  </a-card>
</template>
<script>
import moment from 'moment'
import STable from '@/components/table/'
import { commonStoreList } from '@/api/common'
import { getStorageInventoryLogs, deleteStorageInventoryLog } from '@/api/storage'
import { CODE_FAIL, TYPE_PANYING, TYPE_PANKUI } from '@/store/mutation-types'
export default {
  components: {
    STable
  },
  data () {
    return {
      TYPE_PANYING,
      TYPE_PANKUI,
      storeData: null,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },

      form: this.$form.createForm(this),
      format: 'YYYY-MM-DD',
      supplierModalVisible: false,
      // 查询参数
      queryParam: {
        s_date: '',
        e_date: '',
        storeId: '0'
      },
      // 表头
      columns: [
        {
          title: '盘点时间',
          dataIndex: 'pdDate',
          className: 'text-center'
        },
        {
          title: '盘点编号',
          dataIndex: 'pdNo',
          scopedSlots: { customRender: 'pdNo' },
          className: 'text-center'
        },
        {
          title: '盘点仓库',
          className: 'text-center',
          scopedSlots: { customRender: 'storeId' }
        },
        {
          title: '盘点结果',
          dataIndex: 'pdResult',
          scopedSlots: { customRender: 'pdResult' },
          className: 'text-center'
        },
        {
          title: '操作',
          dataIndex: 'action',
          className: 'text-center',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return getStorageInventoryLogs(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.result
          })
      }
    }
  },
  created () {
    this.queryParam.s_date = moment().add(0, 'month').format('YYYY-MM') + '-01'
    this.queryParam.e_date = moment(this.queryParam.s_date).add(1, 'month').add(-1, 'days').format(this.format)
    this.loadStore()
  },
  methods: {
    moment,
    loadStore () {
      commonStoreList({ all: true }).then(res => {
        this.storeData = res.result.data
      })
    },
    dateChange (date, dateString) {
      this.queryParam.s_date = dateString[0]
      this.queryParam.e_date = dateString[1]
    },
    tableSearch () {
      this.$refs.table.refresh(true)
    },
    deleteConfirm (id) {
      deleteStorageInventoryLog({ id: id }).then((res) => {
        if (res.status !== CODE_FAIL) {
          this.$message.success('删除成功')
          this.tableSearch()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    toInventory (record) {
      this.$router.push({ path: '/storage/inventory', query: { pdNo: record.pdNo, storeId: record.storeId } })
    },
    relBillPath (transType, billId) {
      if (transType === TYPE_PANYING) {
        return '/storage/other/in/edit/' + billId
      } else {
        return '/storage/other/out/edit/' + billId
      }
    }
  },
  watch: {
  }
}
</script>
<style>

  th.text-right, td.text-right {
    text-align: right !important;
  }
  th.text-center, td.text-center {
    text-align: center !important;
  }
</style>
